import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label } from "reactstrap";

const StageModal = ({ isOpen, toggle, mode, selectedStage, onSuccess, createStage, updateStage }) => {
  const [name, setName] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  useEffect(() => {
    if (mode === "edit" && selectedStage) {
      setName(selectedStage.name || "");
      setSortOrder(selectedStage.sort_order !== undefined ? selectedStage.sort_order : "");
    } else {
      setName("");
      setSortOrder("");
    }
  }, [mode, selectedStage, isOpen]);

  const handleSubmit = async () => {
    if (!name) return alert("Stage name is required");

    const payload = {
      name,
      sort_order: sortOrder !== "" ? Number(sortOrder) : 0,
    };

    if (mode === "create") {
      await createStage(payload);
    } else {
      await updateStage(selectedStage._id, payload);
    }

    onSuccess();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {mode === "create" ? "Add New Stage" : "Edit Stage"}
      </ModalHeader>

      <ModalBody>
        <FormGroup className="mb-3">
          <Label className="fw-semibold">Stage Name <span className="text-danger">*</span></Label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter stage name (e.g. New Lead, Interested)"
          />
        </FormGroup>

        <FormGroup className="mb-3">
          <Label className="fw-semibold">Sort Order (Ascending Priority)</Label>
          <Input
            type="number"
            min="0"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            placeholder="Enter numerical position (e.g. 1, 2, 3)"
          />
          <small className="text-muted">
            Stages will be ordered by this number in ascending order (1 comes before 2).
          </small>
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle}>Cancel</Button>
        <Button color="primary" onClick={handleSubmit}>
          {mode === "create" ? "Add Stage" : "Save Changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StageModal;